import { ListProps } from "./types";

import styles from "./styles.module.css";

const DEFAULT_NUMBER_OF_ROWS = 6;

export function Component<IterableComponentProps>(
  props: ListProps<IterableComponentProps>
) {
  const { IterableComponent, componentPropsList, adRenderers = [] } = props;

  if (!IterableComponent) {
    console.error("No IterableComponent found for List");

    return null;
  }

  if (!componentPropsList?.length) {
    console.warn(`No props passed in for components in List`);

    return null;
  }

  const numberOfRows = Math.min(
    props.numberOfRows || DEFAULT_NUMBER_OF_ROWS,
    componentPropsList.length + adRenderers.length
  );

  const iterableComponents = componentPropsList.map((componentProp) => (
    <IterableComponent {...componentProp} />
  ));

  adRenderers.forEach((ad) => {
    if (ad.adPosition > 0) {
      iterableComponents.splice(ad.adPosition - 1, 0, ad.adRenderer());
    } else {
      console.error(`Invalid ad rendering position. adPosition must be >= 1`);
    }
  });

  return (
    <ul className={styles.listContainer}>
      {[...Array(numberOfRows).fill(true)].map((_row, rowIndex) => (
        <li key={rowIndex} className={styles.iterableComponent}>
          {iterableComponents[rowIndex]}
        </li>
      ))}
    </ul>
  );
}
Component.displayName = "List.Component";
